'use strict';

exports.__esModule = true;

var _styledBase = require('@emotion/styled-base');

var _styledBase2 = _interopRequireDefault(_styledBase);

var _core = require('@emotion/core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return 'You have tried to stringify object returned from `css` function. It isn\'t supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).';
}

var right = process.env.NODE_ENV === 'production' ? {
  name: 'arvrdh-right',
  styles: 'right:35px;;label:right;'
} : {
  name: 'arvrdh-right',
  styles: 'right:35px;;label:right;',
  map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvTWljSWNvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHaUIiLCJmaWxlIjoiLi4vLi4vc3JjL3N0eWxlcy9NaWNJY29uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbmNvbnN0IHJpZ2h0ID0gY3NzYFxuXHRyaWdodDogMzVweDtcbmA7XG5cbmNvbnN0IE1pY0ljb24gPSBzdHlsZWQuZGl2YFxuXHRoZWlnaHQ6IDQwcHg7XG5cdHBvc2l0aW9uOiBhYnNvbHV0ZTtcblx0dG9wOiA4cHg7XG5cdGN1cnNvcjogcG9pbnRlcjtcblx0cmlnaHQ6IDE1cHg7XG5cdCR7KHsgaWNvblBvc2l0aW9uLCBzaG93Q2xlYXIgfSkgPT4ge1xuXHRcdGlmIChzaG93Q2xlYXIgJiYgaWNvblBvc2l0aW9uICE9PSAnbGVmdCcpIHJldHVybiAncmlnaHQ6IDUxcHg7Jztcblx0XHRpZiAoaWNvblBvc2l0aW9uID09PSAncmlnaHQnIHx8IHNob3dDbGVhcikge1xuXHRcdFx0cmV0dXJuIHJpZ2h0O1xuXHRcdH1cblx0XHRyZXR1cm4gbnVsbDtcblx0fX1cblx0JHsoeyBzaG93SWNvbiwgc2hvd0NsZWFyIH0pID0+IHtcblx0XHRpZiAoIXNob3dJY29uICYmIHNob3dDbGVhcikgcmV0dXJuICdyaWdodDogMzJweDsnO1xuXHRcdGlmICghc2hvd0ljb24gJiYgIXNob3dDbGVhcikgcmV0dXJuICdyaWdodDogMTVweDsnO1xuXHRcdHJldHVybiBudWxsO1xuXHR9fVxuICB3aWR0aDogMTFweDtcbmA7XG5cbmV4cG9ydCBkZWZhdWx0IE1pY0ljb247XG4iXX0= */',
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var MicIcon = (0, _styledBase2["default"])('div', {
  target: 'e1eg17i10',
  label: 'MicIcon'
})('height:40px;position:absolute;top:8px;cursor:pointer;right:15px;', function (_ref) {
  var iconPosition = _ref.iconPosition,
      showClear = _ref.showClear;
  if (showClear && iconPosition !== 'left') return 'right: 51px;';

  if (iconPosition === 'right' || showClear) {
    return right;
  }

  return null;
}, ' ', function (_ref2) {
  var showIcon = _ref2.showIcon,
      showClear = _ref2.showClear;
  if (!showIcon && showClear) return 'right: 32px;';
  if (!showIcon && !showClear) return 'right: 15px;';
  return null;
}, ' width:11px;' + (process.env.NODE_ENV === 'production' ? '' : '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMvTWljSWNvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPMEIiLCJmaWxlIjoiLi4vLi4vc3JjL3N0eWxlcy9NaWNJY29uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbmNvbnN0IHJpZ2h0ID0gY3NzYFxuXHRyaWdodDogMzVweDtcbmA7XG5cbmNvbnN0IE1pY0ljb24gPSBzdHlsZWQuZGl2YFxuXHRoZWlnaHQ6IDQwcHg7XG5cdHBvc2l0aW9uOiBhYnNvbHV0ZTtcblx0dG9wOiA4cHg7XG5cdGN1cnNvcjogcG9pbnRlcjtcblx0cmlnaHQ6IDE1cHg7XG5cdCR7KHsgaWNvblBvc2l0aW9uLCBzaG93Q2xlYXIgfSkgPT4ge1xuXHRcdGlmIChzaG93Q2xlYXIgJiYgaWNvblBvc2l0aW9uICE9PSAnbGVmdCcpIHJldHVybiAncmlnaHQ6IDUxcHg7Jztcblx0XHRpZiAoaWNvblBvc2l0aW9uID09PSAncmlnaHQnIHx8IHNob3dDbGVhcikge1xuXHRcdFx0cmV0dXJuIHJpZ2h0O1xuXHRcdH1cblx0XHRyZXR1cm4gbnVsbDtcblx0fX1cblx0JHsoeyBzaG93SWNvbiwgc2hvd0NsZWFyIH0pID0+IHtcblx0XHRpZiAoIXNob3dJY29uICYmIHNob3dDbGVhcikgcmV0dXJuICdyaWdodDogMzJweDsnO1xuXHRcdGlmICghc2hvd0ljb24gJiYgIXNob3dDbGVhcikgcmV0dXJuICdyaWdodDogMTVweDsnO1xuXHRcdHJldHVybiBudWxsO1xuXHR9fVxuICB3aWR0aDogMTFweDtcbmA7XG5cbmV4cG9ydCBkZWZhdWx0IE1pY0ljb247XG4iXX0= */'));
exports["default"] = MicIcon;